module.exports = __webpack_public_path__ + "img/IT0000643858428.e807cc04.png";